import { render } from "./ProductsSearchList.vue?vue&type=template&id=5e28d72e&ts=true"
import script from "./ProductsSearchList.vue?vue&type=script&lang=ts"
export * from "./ProductsSearchList.vue?vue&type=script&lang=ts"

import "./ProductsSearchList.vue?vue&type=style&index=0&id=5e28d72e&lang=css"

import exportComponent from "C:\\Data\\TCF\\ABBp_PIS\\6.12\\PisNextGenExtTrain-PisApp_6_12_0\\PisNextGenExtTrain\\PisNextGen\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__